
import { Component, Vue } from 'vue-property-decorator';

import Form16ProcessHeader from "@/components/process/Form16/components/Form16ProcessHeader.vue";
import { form16StatusInfoType } from '@/types/Information/Form16';

@Component({
    components:{
        Form16ProcessHeader
    }
})
export default class CancelSubmitForm16 extends Vue {

    stepsCompleted = {} as form16StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
